import { PatientsTableColumnKeys } from "./../../../enums/tableColumnKeys";
import { Patient } from "risa-data-model";
import {
  TableCellType,
  TableHeader,
} from "../../../components/custom-table/table";

import {
  generateFullName,
  getMemberIdOfPatient,
} from "../../../utils/generateOrderDataForTable";
import moment from "moment";
import { PatientData } from "../../../data-model/PatientData";
import { PatientDataWithId } from "../../../redux/slice/patients-slice";
import { capitalizeString } from "../../../utils/stringModifications";

export const PatientTableColumns: TableHeader[] = [
  {
    label: "Patient Name",
    key: PatientsTableColumnKeys.PatientName,
    order: 1,
    width: 20,
    sortable: true,
    type: TableCellType.STRING,
  },
  {
    label: "MRN",
    key: PatientsTableColumnKeys.PatientId,
    order: 2,
    width: 10,
    sortable: true,
    type: TableCellType.STRING,
  },
  {
    label: "Plan Name",
    key: PatientsTableColumnKeys.PlanName,
    order: 3,
    width: 20,
    sortable: true,
    type: TableCellType.STRING,
  },
  {
    label: "Member ID",
    key: PatientsTableColumnKeys.PlanId,
    order: 4,
    width: 10,
    sortable: false,
    type: TableCellType.STRING,
  },
  {
    label: "DOB",
    key: PatientsTableColumnKeys.Dob,
    order: 5,
    width: 10,
    sortable: true,
    type: TableCellType.STRING,
  },
  {
    label: "State",
    key: PatientsTableColumnKeys.State,
    order: 6,
    width: 10,
    sortable: true,
    type: TableCellType.STRING,
  },
  {
    label: "Primary Provider",
    key: PatientsTableColumnKeys.PrimaryProvider,
    order: 7,
    width: 20,
    sortable: true,
    type: TableCellType.STRING,
  },
];

export function generatePatientData(
  patientData: PatientDataWithId[],
): PatientData[] {
  return patientData.map((patient) => {
    const patientName = capitalizeString(
      generateFullName(
        patient?.Demographics?.FirstName || "",
        patient.Demographics?.MiddleName || "",
        patient.Demographics?.LastName || "",
      ),
    );

    const patientId = getMemberIdOfPatient(patient as Patient) || "N/A";
    const planName = "N/A";
    const planId = "N/A";
    const dob =
      moment(patient?.Demographics?.DOB).format("DD/MM/YYYY") || "N/A";
    const state = patient?.Demographics?.Address?.State || "N/A";
    const primaryProvider = "N/A";
    const docId = patient?.id;

    return {
      patientName,
      patientId,
      planName,
      planId,
      dob,
      state,
      primaryProvider,
      docId,
    };
  });
}
